import { Row, Col, Button, notification, Divider, Pagination, Spin, Empty } from "antd";
import { EditOutlined, DeleteOutlined, SendOutlined, ReloadOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import axios from "axios";
import dayjs from "dayjs";

import Create from "../components/Notification/Create";
import Update from "../components/Notification/Update";
import Delete from "../components/Notification/Delete";

import endpoints from "../utils/endpoints";

import CustomTable from "../components/Table";

function Notifications() {
  const [isLoading, setIsLoading] = useState(true);

  const [data, setData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [selectedData, setSelectedData] = useState({});

  const [isOpenCreate, setIsOpenCreate] = useState(false);
  const [isOpenUpdate, setIsOpenUpdate] = useState(false);
  const [isOpenDelete, setIsOpenDelete] = useState(false);

  useEffect(() => {
    handleGetData();
  }, []);

  function handleGetData() {
    setIsLoading(true);
    axios
      .get(endpoints.notification.read)
      .then((res) => {
        console.log(res);
        let auxData = [];
        for (let i = 0; i < res.data.length; i++) {
          let arrayData = res.data[i];
          let aux = {
            key: i + 1,
            id: arrayData.id,
            title: arrayData.title,
            description: arrayData.description,
            date_time: arrayData.date_time ? dayjs(arrayData.date_time).format("DD-MM-YYYY HH:mm:ss") : "Sem data",
            status: arrayData.sended ? "Enviada" : "Pendente",
            actions: (
              <div className="flex justify-end items-center">
                {!arrayData.sended && (
                  <Button className="flex justify-center items-center">
                    <EditOutlined className="edit-action" onClick={() => handleOpenUpdate(arrayData)} />
                  </Button>
                )}
                <Button danger className="flex justify-center items-center">
                  <DeleteOutlined className="delete-action" onClick={() => handleOpenDelete(arrayData)} />
                </Button>
              </div>
            ),
          };

          auxData.push(aux);
        }

        setTableData(auxData);
        setData(res.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  }

  function handleOpenCreate() {
    setIsOpenCreate(true);
  }

  function handleCloseCreate() {
    setIsOpenCreate(false);
    handleGetData();
  }

  function handleOpenUpdate(data) {
    setSelectedData(data);
    setIsOpenUpdate(true);
  }

  function handleCloseUpdate() {
    setIsOpenUpdate(false);
    setSelectedData({});
    handleGetData();
  }

  function handleOpenDelete(data) {
    setSelectedData(data);
    setIsOpenDelete(true);
  }

  function handleCloseDelete() {
    setIsOpenDelete(false);
    setSelectedData({});
    handleGetData();
  }

  return (
    <div className="dashboard-page">
      <Create open={isOpenCreate} close={handleCloseCreate} />
      <Update data={selectedData} open={isOpenUpdate} close={handleCloseUpdate} />
      <Delete data={selectedData} open={isOpenDelete} close={handleCloseDelete} />
      <Row className="dashboard-title-row">
        <Col span={12} className="flex justify-start items-center">
          <h3 className="dashboard-title">Notificações</h3>
        </Col>
        <Col span={12} className="flex justify-end items-center">
          <Button className="flex justify-center items-center mr-2" size="large" onClick={handleGetData}>
            <ReloadOutlined />
          </Button>
          <Button type="primary" size="large" onClick={handleOpenCreate}>
            Adicionar
          </Button>
        </Col>
      </Row>
      <Divider />
      <Spin spinning={isLoading}>
        <Row className="dashboard-content-row">
          <Col xs="24" xl={24}>
            <CustomTable
              dataSource={tableData}
              columns={[
                { title: "Título", dataIndex: "title", key: "title" },
                { title: "Descrição", dataIndex: "description", key: "description" },
                { title: "Data", dataIndex: "date_time", key: "date_time" },
                { title: "Status", dataIndex: "status", key: "status" },
                { title: "", dataIndex: "actions", key: "actions" },
              ]}
            />
          </Col>
        </Row>
      </Spin>
    </div>
  );
}

export default Notifications;
